// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

/** Bearer token for same-origin `/api/*` calls (Firebase ID token). */
export async function getFirebaseAuthHeader(forceRefresh = false) {
  try {
    await auth.authStateReady();
    const user = auth.currentUser;
    if (!user) {
      console.warn("[firebase] getFirebaseAuthHeader: no signed-in user", { forceRefresh });
      return {};
    }
    const token = await user.getIdToken(forceRefresh);
    console.log("[firebase] getFirebaseAuthHeader: token ready", {
      uid: user.uid,
      forceRefresh,
      tokenLength: token.length,
      projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || null,
    });
    return { Authorization: `Bearer ${token}` };
  } catch (err) {
    console.error("[firebase] getFirebaseAuthHeader failed:", err?.message || err);
    return {};
  }
}